import { Stack, Typography } from "@mui/material";
import { ReactNode, useState } from "react";

interface ConversationListItemProps {
  name: string;
  count: number;
  secondaryAction?: ReactNode;
  icon?: ReactNode;
}

export function ConversationListItem({ name, count, icon, secondaryAction }: ConversationListItemProps) {
  const [showAction, setShowAction] = useState(false);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onMouseEnter={() => setShowAction(true)}
      onMouseLeave={() => setShowAction(false)}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {icon}
        <Typography>{name}</Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        {!!count && <Typography>{count}</Typography>}
        {showAction && secondaryAction}
      </Stack>
    </Stack>
  );
}
